
import { Component, Prop, PropSync, Vue } from 'nuxt-property-decorator'
import IconMobile from '~/components/icons/IconMobile.vue'
import IconHome from '~/components/icons/IconHome.vue'
import IconBundle from '~/components/icons/IconBundle.vue'
import { OfferType, OfferTypeByShortName, OfferTypeKey } from '~/core/offer.types'
import { getExternalCompareMobileHref, getExternalCompareHomeHref } from '~/utils/external-links.utils'

@Component
export default class OfferTypeSwitcher extends Vue {
  @PropSync('offerType', { required: true, default: '', type: String })
  private selectedOfferType!: OfferTypeKey

  private isActive = false

  get options () {
    return [
      {
        labels: {
          desktop: this.$t('offersCommon.mobilePlans'),
          mobile: this.$t('offersCommon.mobile'),
        },
        icon: IconMobile,
        value: OfferTypeByShortName.mobile,
        href: this.externalCompareMobileHref,
      },
      {
        labels: {
          desktop: this.$t('offersCommon.homePlans'),
          mobile: this.$t('offersCommon.home'),
        },
        icon: IconHome,
        value: OfferTypeByShortName.home,
        href: this.externalCompareHomeHref,
      },
    ]
  }

  get selectedOption () {
    return this.options.find(o => o.value === this.selectedOfferType)
  }

  get switcherClassName () {
    if (!this.selectedOption) {
      return ''
    }

    const type = OfferType[this.selectedOption.value as OfferTypeKey]
    return `offer-switch--${type}`
  }

  onItemClick (offerType: OfferTypeKey) {
    this.isActive = false
    this.setOfferType(offerType)
  }

  setOfferType (offerType: OfferTypeKey) {
    this.selectedOfferType = offerType
  }

  get externalCompareMobileHref (): string {
    return getExternalCompareMobileHref(this.$config.BASE_URL, this.localePath)
  }

  get externalCompareHomeHref (): string {
    return getExternalCompareHomeHref(this.$config.BASE_URL, this.localePath)
  }
}
